module.exports = __webpack_public_path__ + "img/img5-3.39d32344.png";